export default __webpack_public_path__ + "img/b18d50582b8a1f29fc18f3138354c18c.svg";